import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["element", "select"]

  connect() {
    if (this.hasSelectTarget) {
      this.toggle(this.elementTargets, this.selectTarget.value)
    }
  }

  changed(event) {
    this.toggle(this.elementTargets, event.target.value)
  }

  toggle(elements, value) {
    for (let element of elements) {
      if (element.dataset.values.includes(',')) {
        let lists = element.dataset.values.split(',')
        if(lists.includes(value)) {
          element.hidden = false
        }
        else {
          element.hidden = true
        }
      }
      else {
        if (element.dataset.values === value) {
          element.hidden = false
        } else {
          element.hidden = true
        }
      }
    }
  }
}
